import BaseServiceCrud from './BaseServiceCrud';

export default class PartnerService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'partner';
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            email: criteria.email,
            name: criteria.name,
            first_result: criteria.firstResult,
            max_results: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }

    removePartner(id) {
        return this.fetch(`${this.domain}/${this.path}/${id}`, {
            method: 'DELETE',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    update(element) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/`, {
            method: 'PUT',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getPartners(locale) {
        return this.fetch(`${this.domain}/${this.path}/partners/${locale}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    calculateBuildingCoordinates(address) {
        let query = this.objToQueryString({
            street: address.street,
            streetNumber: address.streetNumber,
            postalCode: address.postalCode,
            city: address.city,
            voivodeship: address.voivodeship?.label,
        });
        return this.fetch(`${this.domain}/${this.path}/coordinates${query}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
